export default "__VITE_ASSET__CM38LbHZ__"